import { render } from "./ZhiboPage.vue?vue&type=template&id=3ab3b900&scoped=true"
import script from "./ZhiboPage.vue?vue&type=script&lang=js"
export * from "./ZhiboPage.vue?vue&type=script&lang=js"

import "./ZhiboPage.vue?vue&type=style&index=0&id=3ab3b900&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab3b900"]])

export default __exports__